import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 34px',
    border: `1px solid ${Colors.Gray1}`,
    borderRadius: 2,
    backgroundColor: Colors.White,
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.05)',
    marginBottom: 15,
  },
  nameWrapper: {
    width: '25%',
  },
  name: {
    cursor: 'pointer',
    fontSize: '15px !important',
  },
  transitionDisabled: {
    '&.MuiTypography-root':{
      color: Colors.Gray,
      cursor: 'default',
    },
  },
  summary: {
    fontSize: 13,
  },
  date: {
    fontSize: '13px !important',
    width: '25%',
  },
  status: {
    borderRadius: 14.5,
    backgroundColor: Colors.Green3,
    width: 123,
    padding: '5px 0',
  },
  pendingStatus: {
    backgroundColor: Colors.Orange,
    '& $statusText': {
      color: Colors.White,
    },
  },
  submittedStatus: {
    backgroundColor: Colors.Red,
    '& $statusText': {
      color: Colors.White,
    },
    marginRight: '15.9%',
  },
  finishedStatus: {
    backgroundColor: Colors.Green3,
    '& $statusText': {
      color: Colors.White,
    },
  },
  statusText: {
    fontSize: '13px !important',
    color: Colors.White,
    textAlign: 'center',
  },
  button: {
    color: `${Colors.Blue1} !important`,
  },
  reportWrapper: {
    height: 0,
    overflow: 'hidden',
  },
  calculationsNameInput: {
    width: 500,
  },
}));

export default useStyles;
